import { Order, firestoreDateParser, EndOrderDetailDigitalPayment } from '@pedix-workspace/utils';
import { withNestedConverter } from './utils';
import { parseMarketplaceOrderDates } from './utils/marketplace-order';
import { parseOrderTableDates } from './utils/order-table';

/**
 * Infers the payment provider from a payment link URL.
 * Used for backward compatibility when migrating from paymentLink to digitalPayment.
 */
function inferProviderFromUrl(url?: string): EndOrderDetailDigitalPayment['provider'] | undefined {
  if (!url) return undefined;

  if (url.includes('mercadopago')) return 'mercadopago';
  if (url.includes('zenrise')) return 'zenrise';
  if (url.includes('uala')) return 'uala';
  if (url.includes('chytapay')) return 'chytapay';
  if (url.includes('cucuru')) return 'cucuru';

  return undefined;
}

export const getOrderConverter = withNestedConverter<Order>({
  fromFirestore(snapshot) {
    const order = <Order>snapshot.data();

    // Handle new digitalPayment field (priority)
    let digitalPayment = order.digitalPayment
      ? {
          ...order.digitalPayment,
          updated: firestoreDateParser(order.digitalPayment.updated),
        }
      : undefined;

    // On-read migration: convert legacy paymentLink to digitalPayment format
    if (!digitalPayment && order.paymentLink) {
      digitalPayment = {
        type: 'link',
        status: order.paymentLink.status,
        id: order.paymentLink.id,
        url: order.paymentLink.url,
        updated: firestoreDateParser(order.paymentLink.updated),
        provider: inferProviderFromUrl(order.paymentLink.url),
      };
    }

    return <Order>{
      ...order,
      id: snapshot.id,
      date: firestoreDateParser(order.date),
      updated: firestoreDateParser(order.updated || order.date),
      status: order.status || 'completed',
      digitalPayment,
      marketplaceOrder: parseMarketplaceOrderDates(order.marketplaceOrder),
      table: parseOrderTableDates(order.table),
      payments: order.payments?.map(payment => ({
        ...payment,
        at: firestoreDateParser(payment.at),
      })),
      paymentLink: undefined, // Never return legacy field
    };
  },
  toFirestore(order: Order): Order {
    return order;
  },
});
